// Blog authors and interview guests. A post's `authors` and `interviewees`
// in data/posts.ts both hold ids from this same map — a guest isn't a Pine59
// author, but reuses the same name/role/avatar shape.
// `avatar` is a /public path; when it's missing the byline falls back to an
// initials chip (same treatment as the founder cards on /about).
//
// TODO: add photos for vemund, alexei.

export type Author = {
  name: string
  role?: string
  avatar?: string
  initials: string
}

export const AUTHORS: Record<string, Author> = {
  torage: {
    name: "Tor Åge Ballo",
    role: "Co-founder, Pine59",
    avatar: "/team/torage.jpg",
    initials: "TÅ",
  },
  thomas: {
    name: "Thomas Walle",
    role: "Co-founder, Pine59",
    avatar: "/team/thomas.jpg",
    initials: "TW",
  },
  kjartan: {
    name: "Kjartan Slette",
    role: "Co-founder, Pine59",
    avatar: "/team/kjartan.jpg",
    initials: "KS",
  },
  izabela: {
    name: "Izabela Szymczyk",
    role: "Software Developer, Pine59",
    avatar: "/team/izabela.jpg",
    initials: "IS",
  },
  frode: {
    name: "Frode Bjerke",
    role: "Principal Engineer, Pine59",
    avatar: "/team/frode.jpg",
    initials: "FB",
  },
  vemund: { name: "Vemund Refnin", initials: "VR" },

  // Interview guests — not Pine59 authors, credited via `interviewees`.
  alexei: {
    name: "Alexei Agratchev",
    role: "CEO, RetailNext",
    initials: "AA",
  },
}

export function getAuthors(ids: string[] | undefined): Author[] {
  return (ids ?? []).map((id) => AUTHORS[id]).filter(Boolean)
}

// "A", "A and B", "A and 2 others" — for a byline. Kept short so it fits a card.
export function authorNames(authors: Author[]): string {
  const names = authors.map((a) => a.name)
  if (names.length <= 1) return names[0] ?? ""
  if (names.length === 2) return `${names[0]} and ${names[1]}`
  return `${names[0]} and ${names.length - 1} others`
}
